// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__mJx-S","show":"styles_show__ol2qE","hide":"styles_hide__23Q8F","placeholder":"styles_placeholder__rcSza"};